module.exports = __webpack_public_path__ + "static/media/alexandra.ddfd43ea.jpeg";